/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Modal from '@mui/material/Modal'
import { Button, Link } from '@mui/material'
import { useTranslation } from './hooks/useTranslation'

const sx = {
	modal: {
		background: 'rgba(0,0,0,0.7)',
		backdropFilter: 'blur(5px)',
		width: '100%',
		height: '100%',
	},
	modalContent: {
		'position': 'absolute' as 'absolute',
		'top': '50%',
		'left': '50%',
		'transform': 'translate(-50%, -50%)',
		'background': '#FFF',
		'color': '#161420',
		'padding': '14px',
		'width': '800px',
		'borderRadius': '6px',
		'border': '1px solid #25252533',
		'overflow': 'scroll',
		'scrollbarWidth': 'none',
		'height': '90%',
		'@media (max-width: 460px)': {
			width: '100%',
			height: '100%',
		},
	},
	tc_text: {
		'textAlign': 'center',
		'fontSize': '12px',
		'color': '#FFF',
		'display': 'block',
		'@media (max-width: 460px)': {
			fontSize: '13px',
		},
	},
	tc_link: {
		'fontSize': '12px',
		'fontWeight': 600,
		'lineHeight': '110%',
		'color': '#FFF',
		'textDecoration': 'none',
		'marginLeft': '3px',
		'&:hover': {
			opacity: 0.7,
		},
	},
	tc_modal_title: {
		fontSize: '18px',
		marginBottom: '14px',
		fontWeight: '700',
	},
	tc_button: {
		'marginTop': 'auto',
		'width': '100%',
		'background': '#252525',
		'color': '#FFF',
		'fontSize': '15px',
		'border': 'none',

		'&:hover': {
			border: 'none',
			backgroundColor: '#252525',
			opacity: 0.7,
		},
		'@media (max-width: 460px)': {
			marginTop: '70px',
		},
	},
}

export default function Terms() {
	const [open, setOpen] = React.useState(false)
	const handleOpen = () => setOpen(true)
	const handleClose = () => setOpen(false)
	const { getTexts } = useTranslation(false)
	const modalText = getTexts('tc_modal_text')
	return (
		<Box>
			<Typography component={'span'} sx={sx.tc_text} onClick={handleOpen}>
				<Link href="#" sx={sx.tc_link}>
					{getTexts('tc_link')}
				</Link>
			</Typography>

			<Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" sx={sx.modal}>
				<Box sx={sx.modalContent}>
					<Typography id="modal-modal-title" variant="h6" component="h2" sx={sx.tc_modal_title}>
						{getTexts('tc_modal_title')}
					</Typography>
					<Typography id="modal-modal-description" variant="body1">
						<div dangerouslySetInnerHTML={{ __html: modalText }}></div>
					</Typography>
					<Button onClick={handleClose} variant="outlined" sx={sx.tc_button}>
						{getTexts('tc_modal_button')}
					</Button>
				</Box>
			</Modal>
		</Box>
	)
}
